const contactDrillDownfilterSortReducer = (
    state = {},
    action: {
      type: "SET_CONTACTDRILLDOWN_FILTER_SORT";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_CONTACTDRILLDOWN_FILTER_SORT":
        return { ...action.payload };
  
      default:
        return state;
    }
  };
  
  export default contactDrillDownfilterSortReducer;